// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cdx-attaches--with-file .cdx-attaches--anchor {
      display: flex;
      padding: 13px 20px;
      border: 1px solid #e6e9eb;
      border-radius: 3px;
      background: #fff;
      color: #333;
      text-decoration: none;
    }
      .cdx-attaches--with-file .cdx-attaches--anchor:hover {
        background: #fafafa;
      }
      .cdx-attaches--with-file .cdx-attaches--anchor:hover .cdx-attaches__file-icon::before {
            background: #fafafa;
          }
    .cdx-attaches--with-file .cdx-attaches__file-info {
      flex-grow: 8;
      max-width: calc(100% - 80px);
    }
    .cdx-attaches--with-file .cdx-attaches__download-button {
      display: flex;
      align-items: center;
    }
    .cdx-attaches--with-file .cdx-attaches__download-button svg {
        fill: #7b7e89;
      }
    .cdx-attaches--with-file .cdx-attaches__file-icon {
      margin-right: 20px;
      position: relative;
    }
    .cdx-attaches--with-file .cdx-attaches__file-icon::before {
        position: absolute;
        bottom: 7px;
        left: 8.5px;
        font-size: 8px;
        font-weight: 900;
        text-transform: uppercase;
        background: #fff;
        line-height: 150%;
        content: attr(data-extension);
      }
    .cdx-attaches--with-file .cdx-attaches__file-icon svg {
        fill: currentColor;
      }
    .cdx-attaches--with-file .cdx-attaches__size {
      color: #7b7e89;
    }
    .cdx-attaches--with-file .cdx-attaches__size::after {
        content: attr(data-size);
        margin-left: 0.2em;
      }
    .cdx-attaches--with-file .cdx-attaches__title {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      outline: none;
      max-width: 90%;
    }
  .cdx-attaches--loading .cdx-attaches__title,
    .cdx-attaches--loading .cdx-attaches__file-icon,
    .cdx-attaches--loading .cdx-attaches__size,
    .cdx-attaches--loading .cdx-attaches__download-button,
    .cdx-attaches--loading .cdx-attaches__button {
      opacity: 0;
      font-size: 0;
    }
  .cdx-attaches__button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .cdx-attaches__button svg {
      height: 14px;
      margin-top: 0;
      margin-right: 8px;
    }
  .cdx-attaches__button:hover {
      color: #393f52;
    }
`, "",{"version":3,"sources":["webpack://./mock/src/js/Libs/editorjs/attaches/index.css"],"names":[],"mappings":"AAEI;MACE,aAAa;MACb,kBAAkB;MAClB,yBAAyB;MACzB,kBAAkB;MAClB,gBAAgB;MAChB,WAAW;MACX,qBAAqB;IASvB;MARE;QACE,mBAAmB;MAMrB;MAJI;YACE,mBAAmB;UACrB;IAKN;MACE,YAAY;MACZ,4BAA4B;IAC9B;IAEA;MACE,aAAa;MACb,mBAAmB;IAKrB;IAHE;QACE,aAAa;MACf;IAGF;MACE,kBAAkB;MAClB,kBAAkB;IAiBpB;IAfE;QACE,kBAAkB;QAClB,WAAW;QACX,WAAW;QACX,cAAc;QACd,gBAAgB;QAChB,yBAAyB;QACzB,gBAAgB;QAChB,iBAAiB;QACjB,6BAA6B;MAC/B;IAEA;QACE,kBAAkB;MACpB;IAGF;MACE,cAAc;IAMhB;IAJE;QACE,wBAAwB;QACxB,kBAAkB;MACpB;IAGF;MACE,mBAAmB;MACnB,uBAAuB;MACvB,gBAAgB;MAChB,aAAa;MACb,cAAc;IAChB;EAIA;;;;;MAKE,UAAU;MACV,YAAY;IACd;EAGF;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EAWzB;EATE;MACE,YAAY;MACZ,aAAa;MACb,iBAAiB;IACnB;EAEA;MACE,cAAc;IAChB","sourcesContent":[".cdx-attaches {\n  &--with-file {\n    ^&--anchor {\n      display: flex;\n      padding: 13px 20px;\n      border: 1px solid #e6e9eb;\n      border-radius: 3px;\n      background: #fff;\n      color: #333;\n      text-decoration: none;\n      &:hover {\n        background: #fafafa;\n        .cdx-attaches__file-icon {\n          &::before {\n            background: #fafafa;\n          }\n        }\n      }\n    }\n\n    ^&__file-info {\n      flex-grow: 8;\n      max-width: calc(100% - 80px);\n    }\n\n    ^&__download-button {\n      display: flex;\n      align-items: center;\n\n      svg {\n        fill: #7b7e89;\n      }\n    }\n\n    ^&__file-icon {\n      margin-right: 20px;\n      position: relative;\n\n      &::before {\n        position: absolute;\n        bottom: 7px;\n        left: 8.5px;\n        font-size: 8px;\n        font-weight: 900;\n        text-transform: uppercase;\n        background: #fff;\n        line-height: 150%;\n        content: attr(data-extension);\n      }\n\n      svg {\n        fill: currentColor;\n      }\n    }\n\n    ^&__size {\n      color: #7b7e89;\n\n      &::after {\n        content: attr(data-size);\n        margin-left: 0.2em;\n      }\n    }\n\n    ^&__title {\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      outline: none;\n      max-width: 90%;\n    }\n  }\n\n  &--loading {\n    ^&__title,\n    ^&__file-icon,\n    ^&__size,\n    ^&__download-button,\n    ^&__button {\n      opacity: 0;\n      font-size: 0;\n    }\n  }\n\n  &__button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    svg {\n      height: 14px;\n      margin-top: 0;\n      margin-right: 8px;\n    }\n\n    &:hover {\n      color: #393f52;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
